<template>
  <div>
    <h1>Registrar tarifa plana</h1>
    <div class="card">
      <div class="card-body">
        <a-form :form="form" @submit.prevent="handleSubmit" layout="vertical">
          <div class="row">
            <div class="col-md-6">
              <a-form-item label="Nombre de tarifa plana">
                <a-input ref="name" placeholder="Nombre de tarifa plana" v-model="$v.fixedFare.name.$model" />
                <small class="text-danger" v-if="!$v.fixedFare.name.required">Campo requerido. No debe estar vacío.</small><br>
                <!--<small class="text-danger" v-if="!validateRegisteredName($v.fixedFare.name.$model)">Ya existe un registro con este origen y destino</small>-->
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item label="Origen">
                <v-select label="name" :options="getAllSources" v-model="$v.fixedFare.origin.$model"><span slot="no-options">Elemento no encontrado</span></v-select>
                <small class="text-danger" v-if="!$v.fixedFare.origin.required">Campo requerido. No debe estar vacío.</small>
                <!--<small class="text-danger" v-if="!validateRegisteredOriginAndDestiny($v.fixedFare.origin.$model, $v.fixedFare.destination.$model)">Ya existe un registro con este origen y destino</small>-->
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item label="Destino">
                <v-select label="name" :options="getAllDestinations" v-model="$v.fixedFare.destination.$model"><span slot="no-options">Elemento no encontrado</span></v-select>
                <small class="text-danger" v-if="!$v.fixedFare.destination.required">Campo requerido. No debe estar vacío.</small>
                <!--<small class="text-danger" v-if="!validateRegisteredOriginAndDestiny($v.fixedFare.origin.$model, $v.fixedFare.destination.$model)">Ya existe un registro con este origen y destino</small>-->
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item label="Kilómetros de ida">
                <a-input ref="name" placeholder="Kilómetros de ida" v-model="$v.fixedFare.km.$model" />
                <small class="text-danger" v-if="!$v.fixedFare.km.required">Campo requerido. No debe estar vacío.</small><br>
                <small class="text-danger" v-if="!$v.fixedFare.km.decimal">Este campo debe ser decimal</small><br>
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item label="Costo de vialidad">
                <a-input ref="name" placeholder="Costo de vialidad" v-model="$v.fixedFare.freeRoadFare.$model" />
                <small class="text-danger" v-if="!$v.fixedFare.freeRoadFare.required">Campo requerido. No debe estar vacío.</small><br>
                <small class="text-danger" v-if="!$v.fixedFare.freeRoadFare.decimal">Este campo debe ser numérico</small><br>
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item label="Vialidad">
                <v-select label="name" :options="['Carretera libre', 'Caseta']" v-model="$v.type.$model"><span slot="no-options">Elemento no encontrado</span></v-select>
                <small class="text-danger" v-if="!$v.type.required">Campo requerido. No debe estar vacío.</small>
                <!--<small class="text-danger" v-if="!$v.fixedFare.tollwayFare.required">Campo requerido. No debe estar vacío.</small><br>
                <small class="text-danger" v-if="!$v.fixedFare.tollwayFare.decimal">Este campo debe ser numérico</small><br>-->
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item label="Hora pico">
                <a-checkbox v-model="rushHour">
                  Hora pico
                </a-checkbox>
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item label="Preferente">
                <a-checkbox v-model="preferential">
                  Preferente
                </a-checkbox>
              </a-form-item>
            </div>
            <div class="col-12">
              <a-form-item>
                <button ref="button" type="submit" class="btn btn-light px-5" :disabled="!(!$v.$invalid)" v-if="this.clicked === 0">
                  Registrar
                </button>
                <button class="btn btn-gray px-5"  v-else-if="this.clicked === 1">Cargando...</button>
                <button class="btn btn-success px-5"  v-else-if="this.clicked === 2">Se a registrado exitosamente</button>
                <button class="btn btn-danger px-5"  v-else-if="this.clicked === 3">Ha ocurrido un error</button>
              </a-form-item>
            </div>
          </div>
        </a-form>
      </div>
    </div>
  </div>
</template>
<script>
import { required, decimal } from 'vuelidate/lib/validators'
import gql from 'graphql-tag'
import headers from '@/config/headers.js'
const GET_ALL_SOURCES = gql`
  query getAllSources{
    getAllSources{
      id
      name
    }
  }
`
const GET_ALL_DESTINATIONS = gql`
  query getAllDestinations{
    getAllDestinations{
      id
      name
      createdBy
    }
  }
`
const GET_ALL_FIXED_FARES = gql`
query getAllFIxedFares{
  getAllFIxedFares {
    id
    name
    preferential
    source {
      id
      name
    }
    destination{
      id
      name
    }
  }
}
`
const CREATE_FIX_FARE = gql`
  mutation createFixedFare($name: String $freeRoadFare: Float $kmTotal: Float $createdBy: String $sourceId: Int $destinationId: Int $rushHour: Boolean $preferential: Int){
    createFixedFare(fixedfare: { name: $name, freeRoadFare: $freeRoadFare, kmTotal: $kmTotal, createdBy: $createdBy, sourceId: $sourceId, destinationId: $destinationId, rushHour: $rushHour, preferential: $preferential}) {
      id
      name
      preferential
    }
  }
`
export default {
  data() {
    return {
      form: this.$form.createForm(this),
      type: '',
      preferential: false,
      pref: 0,
      fixedFare: {
        name: '',
        origin: {},
        destination: {},
        km: null,
        freeRoadFare: null,
        // tollwayFare: null,
      },
      rushHour: false,
      getAllSources: [],
      getAllDestinations: [],
      registeredOriginAndDestiny: {},
      registeredName: {},
      clicked: 0,
      createdBy: this.$store.state.user.email,
    }
  },
  apollo: {
    getAllSources: {
      query: GET_ALL_SOURCES,
      result({ data }) {
        // console.log(data)
      },
      error(error) {
        console.log(error)
      },
      context: headers(),
    },
    getAllDestinations: {
      query: GET_ALL_DESTINATIONS,
      result({ data }) {
        // console.log(data)
      },
      error(error) {
        console.log(error)
      },
      context: headers(),
    },
    getAllFIxedFares: {
      query: GET_ALL_FIXED_FARES,
      context: headers(),
      result({ data }) {
        data.getAllFIxedFares.forEach(fixedFare => {
          this.registeredOriginAndDestiny[[fixedFare.source.name, fixedFare.destination.name]] = 1
          this.registeredName[fixedFare.name] = 1
        })
        // console.log(this.registeredOriginAndDestiny)
      },
      error(error) {
        console.log(error)
      },
    },
  },
  methods: {
    handleSubmit() {
      console.log(this.preferential, 'pref')
      if (this.preferential === true) {
        this.pref = 1
      } else {
        this.pref = 0
      }
      if (this.clicked === 0) {
        console.log(this.pref, 'pref2')
        this.clicked = 1
        this.$apollo.mutate({
          mutation: CREATE_FIX_FARE,
          variables: {
            name: this.fixedFare.name + ' ' + this.type,
            freeRoadFare: parseFloat(this.fixedFare.freeRoadFare),
            // tollwayFare: parseFloat(this.fixedFare.tollwayFare),
            kmTotal: parseFloat(this.fixedFare.km),
            createdBy: this.createdBy,
            sourceId: parseInt(this.fixedFare.origin.id),
            destinationId: parseInt(this.fixedFare.destination.id),
            rushHour: this.rushHour,
            preferential: this.pref,
          },
          context: headers(),
        })
          .then(data => {
            console.log(data)
            this.clicked = 2
            this.$router.push('/tarifasPlanas/tarifasPlanas')
          })
          .catch(error => {
            this.clicked = 3
            console.log(error)
          })
        this.disabledButton = true
      }
    },
    validateRegisteredOriginAndDestiny(origin, destiny) {
      if (this.registeredOriginAndDestiny[[origin.name, destiny.name]]) {
        return false
      } else {
        return true
      }
    },
    validateRegisteredName(name) {
      if (this.registeredName[name.trim()]) {
        return false
      } else {
        return true
      }
    },
  },
  validations: {
    type: { required },
    fixedFare: {
      name: { required },
      origin: { required },
      destination: { required },
      km: { required, decimal },
      freeRoadFare: { required, decimal },
      // tollwayFare: { required, decimal },
    },
  },
}
</script>
